import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/content';

interface NewsCardProps {
  article: NewsArticle;
  layout?: 'vertical' | 'horizontal';
}

export default function NewsCard({ article, layout = 'vertical' }: NewsCardProps) {
  if (layout === 'horizontal') {
    return (
      <Link
        to={`/news/${article.id}`}
        className="group flex gap-4 bg-background-50 border border-background-200 rounded-lg overflow-hidden p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-28 h-20 md:w-40 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} - 影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-col gap-2 min-w-0">
          <div className="flex items-center gap-2 text-[11px]">
            <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">{article.category}</span>
            <span className="text-foreground-400">{article.date}</span>
          </div>
          <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-2 hidden sm:block leading-relaxed">{article.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-full aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4">
        <div className="flex items-center gap-2 text-[11px]">
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">{article.category}</span>
          <span className="text-foreground-400">{article.date}</span>
        </div>
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.summary}</p>
      </div>
    </Link>
  );
}